import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

type UpdateBillingInput = {
  companyId: string;
  billingType: 'FIXED' | 'PER_UNIT' | null;
  billingAmount: number | null;
  minimumBillingAmount: number | null;
  billingStartDate: string | null;
  statedClientCount: number | null;
};

export const useUpdateBillingMutation = () => {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
  } = useMutation<{ data: unknown }, Error, UpdateBillingInput>({
    mutationFn: (input: UpdateBillingInput) =>
      api.patch(`admin/billing/${input.companyId}`, {
        billingType: input.billingType,
        billingAmount: input.billingAmount,
        minimumBillingAmount: input.minimumBillingAmount,
        billingStartDate: input.billingStartDate,
        statedClientCount: input.statedClientCount,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'billing'] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'companies'] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'usage-metrics'] });
    },
  });

  return { updateBilling: mutateAsync, isLoading, error };
};
